<div #dateInputDiv class="ignite-date-container">
  @if (label !== '') {
    <mat-label class="ignite-label">{{ label }}</mat-label>
  }
  <form [formGroup]="form">
    <div class="ignite-date-fields" id="date-of-birth">
      <mat-form-field id="day-field" [hideRequiredMarker]="true" appearance="outline">
        <mat-label>Day</mat-label>
        <mat-select ignite-select formControlName="day" (selectionChange)="updateDate()">
          @for (day of days; track day) {
            <mat-option [value]="day">
              {{ day }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field id="month-field" [hideRequiredMarker]="true" appearance="outline">
        <mat-label>Month</mat-label>
        <mat-select ignite-select formControlName="month" (selectionChange)="updateDate()">
          @for (month of months; track month) {
            <mat-option [value]="month.value">
              {{ month.text }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field id="year-field" [hideRequiredMarker]="true" appearance="outline">
        <mat-label>Year</mat-label>
        <mat-select ignite-select formControlName="year" (selectionChange)="updateDate()">
          @for (year of years; track year) {
            <mat-option [value]="year">
              {{ year }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="mat-mdc-text-field-wrapper" id="ignite-date-error-container">
      <div class="mat-mdc-form-field-subscript-wrapper">
        @if (form.hasError('required')) {
          <mat-error id="dob_error_required">{{ label }} is required</mat-error>
        }
        @if (form.hasError('invalid')) {
          <mat-error id="dob_error_invalid">{{ label }} is invalid</mat-error>
        }
        @if (form.hasError('tooEarly')) {
          <mat-error id="dob_error_min" i18n>{{ label }} is too early</mat-error>
        }
        @if (form.hasError('inFuture')) {
          <mat-error id="dob_error_max" i18n>{{ label }} cannot be in the future</mat-error>
        }
        @if (form.hasError('notLegalAge')) {
          <mat-error id="dob_error_notlegal" i18n
            >Test Taker is 15 or under, they cannot have an account.</mat-error
            >
          }
        </div>
      </div>
    </form>
    @if (showHint) {
      <div class="ignite-date-hint mat-mdc-form-field-subscript-wrapper">
        {{ hint }}
      </div>
    }
  </div>
